export const FUNNEL_STAGES = [
  {
    id: "acquisition",
    label: "Atrair pessoas",
    shortLabel: "Atração",
    description: "Como as pessoas descobrem sua empresa e chegam até o canal desta campanha.",
    example: "Ex.: anúncio, post, indicação ou link compartilhado.",
    volumeLabel: "Pessoas alcançadas",
    conversionLabel: "Chegaram ao próximo passo",
    order: 1,
  },
  {
    id: "capture",
    label: "Captar contato",
    shortLabel: "Captura",
    description: "Momento em que a pessoa deixa um sinal de interesse (comentário, formulário, clique).",
    example: "Ex.: comentário no Instagram ou preenchimento de formulário.",
    volumeLabel: "Interações",
    conversionLabel: "Viraram contato",
    order: 2,
  },
  {
    id: "entry",
    label: "Abrir conversa",
    shortLabel: "Entrada",
    description: "A conversa começa de verdade e o contato entra no seu atendimento.",
    example: "Ex.: criar o lead e iniciar o chat no WhatsApp ou Messenger.",
    volumeLabel: "Conversas abertas",
    conversionLabel: "Seguiram no funil",
    order: 3,
  },
  {
    id: "activation",
    label: "Engajar",
    shortLabel: "Engajamento",
    description: "Primeira resposta útil: mensagem, pergunta ou ajuda para a pessoa avançar.",
    example: "Ex.: DM automática, menu de opções ou pergunta de diagnóstico.",
    volumeLabel: "Mensagens enviadas",
    conversionLabel: "Responderam",
    order: 4,
  },
  {
    id: "conversion",
    label: "Converter",
    shortLabel: "Conversão",
    description: "Quando o objetivo da campanha acontece: venda, agendamento ou aceite da oferta.",
    example: "Ex.: fechamento de pedido, pagamento ou marcação de horário.",
    volumeLabel: "Oportunidades",
    conversionLabel: "Fecharam",
    order: 5,
  },
  {
    id: "expansion",
    label: "Vender mais",
    shortLabel: "Expansão",
    description: "Oferecer algo a mais para quem já comprou ou já está avançado.",
    example: "Ex.: upgrade de plano, produto complementar ou pacote.",
    volumeLabel: "Clientes elegíveis",
    conversionLabel: "Aceitaram oferta",
    order: 6,
  },
  {
    id: "retention",
    label: "Manter o relacionamento",
    shortLabel: "Retenção",
    description: "Acompanhar depois da compra para a pessoa continuar engajada e voltar.",
    example: "Ex.: lembretes, novidades ou checagem de satisfação.",
    volumeLabel: "Clientes ativos",
    conversionLabel: "Continuaram ativos",
    order: 7,
  },
];

export const TRANSVERSAL_STAGE = {
  id: "recovery",
  label: "Recuperar quem parou",
  shortLabel: "Recuperação",
  description:
    "Retomar contato com quem esfriou, não respondeu ou abandonou no meio do caminho.",
  example: "Ex.: follow-up, e-mail de retomada ou nova mensagem no mesmo canal.",
  volumeLabel: "Contatos parados",
  conversionLabel: "Voltaram a responder",
  order: 8,
};

export function getStageDefinition(stageId) {
  if (stageId === TRANSVERSAL_STAGE.id) return TRANSVERSAL_STAGE;
  return FUNNEL_STAGES.find((s) => s.id === stageId) || null;
}

export function getStageUxConfig(flowConfig, stageId) {
  const cfg = flowConfig && typeof flowConfig === "object" ? flowConfig : {};
  const ux = cfg.uxFunnel && typeof cfg.uxFunnel === "object" ? cfg.uxFunnel : {};
  const stages = ux.stages && typeof ux.stages === "object" ? ux.stages : {};
  const v = stages[stageId];
  return v && typeof v === "object" ? v : {};
}

export function isStageConfigured(flowConfig, stageId) {
  const ux = getStageUxConfig(flowConfig, stageId);
  if (Object.keys(ux).length) return true;
  const hasGraph = !!(flowConfig && typeof flowConfig === "object" && flowConfig.graph);
  return hasGraph;
}
